export const transparentVertexShader = `#version 300 es

in vec2 a_position;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
}
`;

export const transparentFragmentShader = `#version 300 es

precision highp float;

out vec4 outColor;

void main() {
  outColor = vec4(0, 0, 0, 0);
}
`;
